export class Addtasksubtaskmaster {
    ID:number;
    CLIENT_ID:number;

    MASTER_ID
    SUBTASK_ID
    DATE_TIME
}